<div class="title">
 <div class="title__text bold" [innerHTML]="title">
  </div>
</div>
